// IE 2026 11 01 / ODOO-350597 (дефект Андрея, шина #123143: «когда я кликаю на пейдж … вытягивает список иконок в левом тулбаре вниз,
// а потом после завершения отрисовки возвращает назад»): отступ поля виджетов от низа шапки — ОДНА формула для раскладки страницы
// (MainArea.setStyle_MainContainer) и для рейла страницы без раскладки (Page.pageButtonsStart): низ .topbar (offsetTop + offsetHeight,
// скролл-независимо — см. комментарий в MainArea о тёмной теме) + 9 px + полоса плашки новой версии (store.updateBannerOffset, App.vue
// topBanners_layout) + строка чипсов над страницей (chipsBarPosition = 'page-top'). Ряд предупреждения страницы (.ws-alert-row, 44 px) живёт
// в .topbar и входит в его высоту только на своей странице — поэтому отступ нельзя заимствовать у соседней страницы (так было с ef291ec68).
export const TOPBAR_GAP = 9

// низ шапки в px относительно страницы; null — шапка ещё не смонтирована (AttrChips может встать раньше App)
export function topbarBottom_px(tb) {
    if (!tb || typeof tb.offsetHeight !== 'number') return null
    return Math.ceil(tb.offsetTop + tb.offsetHeight)
}

// высота строки чипсов над страницей, если чипсы вынесены из шапки (chipsBarPosition = 'page-top'); иначе 0
export function pageTopBar_h(store) {
    if ((store?.chipsBarPosition ?? 'topbar') !== 'page-top') return 0
    const el = typeof document !== 'undefined' ? document.querySelector('.page-top-bar') : null
    return el ? el.offsetHeight : 0
}

// stylePage.marginTop страницы; null — низ шапки неизвестен
export function topbarMarginTop({ topbarBottom, updateBannerOffset = 0, pageTopBarH = 0 }) {
    if (topbarBottom == null) return null
    return topbarBottom + TOPBAR_GAP + (updateBannerOffset || 0) + (pageTopBarH ? pageTopBarH + 3 : 0)
}

// выключатель: false — прежнее заимствование отступа у первой разложенной страницы
export const RAIL_TOP_FLAG = 'fe.ux.railTopFromTopbar'
export function railTopFromTopbar_on(setting) { return setting(RAIL_TOP_FLAG, true) !== false }

// IE 2026 11 02 / ODOO-350597 (остаток, замер webscm на бою #123302): плитки рейла (.left-area-button-tab, position: fixed) несут переход top .15s для листания
// рейла; при смене начала рейла (railStart: шапка стала другой высоты — ряд предупреждения, плашка версии) переход попадает в pending на всё время,
// пока главный поток монтирует новую страницу (замер dev 02.11: CSSTransition top running/pending 0 мс ≈300 мс, плитка держит старые 115 px при
// inline 71) — полоса 44 px под уже сжатой шапкой, затем скольжение. При смене railStart переход top снимается на два кадра (Page.vue: класс
// rail-start-jump), плитки прыгают вместе с шапкой. Выключатель fe.ux.railStartNoGlide: false — прежнее скольжение
export const RAIL_JUMP_FLAG = 'fe.ux.railStartNoGlide'
export function railStartNoGlide_on(setting) { return setting(RAIL_JUMP_FLAG, true) !== false }
